import { useState } from 'react';

import { getLocale, setLocale, type Locale } from './i18n';

/**
 * Estado local del selector de idioma ES|PT para las pantallas públicas.
 *
 * `t()` lee el locale global (no reactivo), así que al cambiarlo fijamos el
 * global y forzamos un re-render del componente que use este hook. Cualquier
 * subárbol (header/footer/artículo) que se rendere desde ese componente vuelve
 * a traducirse. Mismo patrón que usa LandingPage.
 */
export function usePublicLocale() {
  const [locale, setLocaleState] = useState<Locale>(getLocale());

  const switchLocale = (next: Locale) => {
    setLocale(next, true); // elección manual → persiste para próximas visitas
    setLocaleState(next);
    document.documentElement.lang = next === 'pt' ? 'pt-BR' : 'es';
  };

  return { locale, switchLocale };
}
